<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">
        {{ topTitle }}
      </div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="titleData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <!-- 发货 -->
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
    <!-- 详情 -->
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce } from "@/utils/myUtils";
import { processOutsourcingReceive_list } from "@/api/myController/outsourcing";
export default {
  name: "outsourcingProcesses_return",
  props: {
    titleData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false,
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 0,
      // ------------------------------
      type: 1,
      topTitle: "工序委外发货",
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      changeList: [],
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["详情", "删除"],
      // 表内容
      list: [],
      // 合并单元格 供应商编号、采购人、付款模式、已开票金额、未开票金额、已付款金额、未付款金额
      // 表头
      titleList: [
        {
          id: 1,
          name: this.$t("关联订单号"),
          value: "baseProcessOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 1,
          name: this.$t("发货单号"),
          value: "processOutsourcingReceiveDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          color: "#049eff",
          width: 150,
        },
        {
          id: 0,
          name: this.$t("全局搜索码"),
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 6,
          name: this.$t("产品编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 7,
          name: this.$t("产品名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 8,
          name: this.$t("产品规格"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 180,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 9,
          name: this.$t("本次发货数量"),
          value: "baseOutsourcingFinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 120,
        },
        {
          id: 14,
          name: this.$t("状态"),
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: this.$t("已审核"),
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: this.$t("未审核"),
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 90,
        },
        {
          id: 0,
          name: this.$t("入库日期"),
          value: "baseInwarehouseTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 120,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 160,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    $t(val) {
      return val;
    },
    getList() {
      this.listLoading = true;
      processOutsourcingReceive_list({
        orderParam: [this.orderParam],
        processOutsourcingReceiveDtoFilter: this.titleData,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              item.specifications = JSON.parse(item.baseSpecgroupDesc);
            } catch (error) {
              item.specifications = [];
            }
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();

        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "详情":
          this.routeQuery = row;
          this.homeIndex = 172;
          this.htmlDataDialogState.show2 = true;
          break;
        case "删除":
          if (row.statusCheck == 1) {
            this.$message.info("已审核状态不能进行删除！");
            return;
          }
          this.$confirm("确定删除？是否继续" + "？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              processOutsourcingReceive_delete({
                processOutsourcingReceiveDocId: row.processOutsourcingReceiveDocId,
              }).then((res) => {
                this.$message.success("操作成功！");
                this.getList();
              });
            })
            .catch(() => {
              this.$message.info("已取消删除");
            });
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "processOutsourcingReceiveDocNumber":
          this.routeQuery = row;
          this.homeIndex = 172;
          this.htmlDataDialogState.show2 = true;
          break;

        default:
          break;
      }
    },
    changeType() {
      this.type = command;
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
